import humps from 'humps'
import mapKeys from 'lodash/mapKeys'
import { Deserializer } from 'jsonapi-serializer'

export default function (jsonapiData) {
  return new Deserializer({ keyForAttribute: 'camelCase' }).deserialize(jsonapiData)
}

export function formatMeta(meta) {
  return mapKeys(meta, (_value, key) => humps.camelize(key))
}
